export default [
  {
    path: '/order_settings',
    meta: { label: 'Order Settings' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'order_settings',
        meta: {
          label: 'Order Settings',
          permission: 'show_all_order_settings'
        },
        component: () => import('./../../views/orderSettings/index'),
      },
      {
        path: ':id',
        meta: { label: 'Order Setting Details', permission: 'show_single_order_setting' },
        name: 'OrderSetting',
        component: () => import('./../../views/orderSettings/show'),
      },
      {
        path: ':id/edit',
        meta: { label: 'Edit Order Setting', permission: 'edit_order_setting' },
        name: 'EditOrderSetting',
        component: () => import('./../../views/orderSettings/edit')
      },
    ]
  },
  {
    path: '/order_bonus_settings',
    meta: { label: 'Order Bonus Settings' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'order_bonus_settings',
        meta: {
          label: 'Order Settings',
          permission: 'show_all_order_bonus_settings'
        },
        component: () => import('./../../views/order_bonus_settings/index.vue'),
      },
      {
        path: "/order_bonus_settings/create",
        name: "CreateOrderBonusSetting",
        component: () => import("./../../views/order_bonus_settings/create.vue"),
        meta: {
          permission: "create_order_bonus_setting",
        },
      },
      {
        path: "/order_bonus_settings/:id/edit",
        name: "EditOrderBonusSetting",
        component: () => import("@/views/order_bonus_settings/edit.vue"),
        meta: {
          permission: "edit_order_bonus_setting",
        },
      },
      {
        path: "/order_bonus_settings/:id",
        name: "ShowOrderBonusSetting",
        component: () => import("@/views/order_bonus_settings/show.vue"),
        meta: {
          permission: "show_order_bonus_setting",
        },
      },
    ]
  },


  {
    path: "collection-payment-methods",
    name: "collection-payment-methods",
    component: () => import("@/views/paymentmethods/index.vue"),
    meta: {
      permission: "show_all_order_payment_methods",
    },
  },
  {
    path: "order_payment_method/create",
    name: "create_order_payment_method",
    component: () => import("@/views/paymentmethods/create.vue"),
    meta: {
      permission: "create_order_payment_methods",
    },
  },
  {
    path: "order_payment_method/:id/edit",
    name: "edit_order_payment_method",
    component: () => import("@/views/paymentmethods/edit.vue"),
    meta: {
      permission: "edit_order_payment_method",
    },
  },
  {
    path: '/return-reasons',
    meta: { label: 'Return Reasons' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'return-reasons',
        meta: {
          label: 'Return Reasons',
          permission: 'show_all_return_reasons'
        },
        component: () => import('./../../views/return_reasons/index.vue'),
      },
      {
        path: 'create',
        name: 'CreateReturnReason',
        meta: {
          label: 'Create Return Reason',
          permission: 'create_return_reason'
        },
        component: () => import('./../../views/return_reasons/create.vue'),
      },
      {
        path: ':id',
        name: 'ShowReturnReason',
        meta: {
          label: 'Return Reason Details',
          permission: 'show_return_reason'
        },
        component: () => import('./../../views/return_reasons/show.vue'),
      },
      {
        path: ':id/edit',
        name: 'EditReturnReason',
        meta: {
          label: 'Edit Return Reason',
          permission: 'edit_return_reason'
        },
        component: () => import('./../../views/return_reasons/edit.vue'),
      },
    ]
  },
  {
    path: '/collection-payment-types',
    meta: { label: 'Collection Payment Types' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'collection-payment-types',
        meta: {
          label: 'Collection Payment Types',
          permission: 'show_all_collection_payment_types'
        },
        component: () => import('./../../views/collection_payment_types/index.vue'),
      },
      {
        path: 'create',
        name: 'CreateCollectionPaymentType',
        meta: {
          label: 'Create Collection Payment Type',
          permission: 'create_collection_payment_type'
        },
        component: () => import('./../../views/collection_payment_types/create.vue'),
      },
      {
        path: ':id',
        name: 'ShowCollectionPaymentType',
        meta: {
          label: 'Collection Payment Type Details',
          permission: 'show_collection_payment_type'
        },
        component: () => import('./../../views/collection_payment_types/show.vue'),
      },
      {
        path: ':id/edit',
        name: 'EditCollectionPaymentType',
        meta: {
          label: 'Edit Collection Payment Type',
          permission: 'edit_collection_payment_type'
        },
        component: () => import('./../../views/collection_payment_types/edit.vue'),
      },
    ]
  },
  {
    path: '/sales-slabs',
    meta: { label: 'Sales Slabs' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'sales-slabs',
        meta: {
          label: 'Sales Slabs',
          permission: 'show_all_sales_slabs'
        },
        component: () => import('./../../views/sales_slabs/index.vue'),
      },
      {
        path: 'create',
        name: 'CreateSalesSlab',
        meta: {
          label: 'Create Sales Slab',
          permission: 'create_sales_slabs'
        },
        component: () => import('./../../views/sales_slabs/create.vue'),
      },
      {
        path: ':id',
        name: 'ShowSalesSlab',
        meta: {
          label: 'Sales Slab Details',
          permission: 'show_sales_slabs'
        },
        component: () => import('./../../views/sales_slabs/show.vue'),
      },
      {
        path: ':id/edit',
        name: 'EditSalesSlab',
        meta: {
          label: 'Edit Sales Slab',
          permission: 'edit_sales_slabs'
        },
        component: () => import('./../../views/sales_slabs/edit.vue'),
      },
    ]
  },
  {
    path: '/marketing-budgets',
    meta: { label: 'Marketing Budgets' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'marketing-budgets',
        meta: {
          label: 'Marketing Budgets',
          permission: 'show_all_marketing_budgets'
        },
        component: () => import('./../../views/marketing_budgets/index.vue'),
      },
      {
        path: 'create',
        name: 'CreateMarketingBudget',
        meta: {
          label: 'Create Marketing Budget',
          permission: 'create_marketing_budgets'
        },
        component: () => import('./../../views/marketing_budgets/create.vue'),
      },
      {
        path: ':id',
        name: 'ShowMarketingBudget',
        meta: {
          label: 'Marketing Budget Details',
          permission: 'show_marketing_budgets'
        },
        component: () => import('./../../views/marketing_budgets/show.vue'),
      },
      {
        path: ':id/edit',
        name: 'EditMarketingBudget',
        meta: {
          label: 'Edit Marketing Budgets',
          permission: 'edit_marketing_budget'
        },
        component: () => import('./../../views/marketing_budgets/edit.vue'),
      },
    ]
  },
  {
    path: '/order_types',
    meta: { label: 'Order Types' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'order_types',
        meta: {
          label: 'Order Types',
          permission: 'show_all_order_types'
        },
        component: () => import('./../../views/orderTypes/index.vue'),
      },
      {
        path: 'create',
        name: 'CreateOrderType',
        meta: {
          label: 'Create Order Type',
          permission: 'create_order_types'
        },
        component: () => import('./../../views/orderTypes/create.vue'),
      },
      {
        path: ':id',
        name: 'ShowOrderType',
        meta: {
          label: 'Order Type Details',
          permission: 'show_order_types'
        },
        component: () => import('./../../views/orderTypes/show.vue'),
      },
      {
        path: ':id/edit',
        name: 'EditOrderType',
        meta: {
          label: 'Edit Order Type',
          permission: 'edit_order_types'
        },
        component: () => import('./../../views/orderTypes/edit.vue'),
      },
    ]
  },
];
